(function () {
	/**
   * Renders Mountain Weather Detail Page (new data structure) — hardened
   * @param {Object} props - Routing/page context
   * @returns {jQuery.Deferred} Promise with data (nav for menu, etc.)
   */
	WebBaseAprovLV.renderMountainWeatherPage = function (props) {
		var Utils = (WebBaseAprovLV && WebBaseAprovLV.Utils) || {};
		var lang = WebBaseAprovLV.lang;
		var dfdRoot = $.Deferred();
		var t0 = (window.performance && performance.now && performance.now()) || Date.now();
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			console.error('[mountain-detail] Utils missing');
			return dfdRoot.reject(new Error('Utils missing')).promise();
		}
		var fetchAsync = Utils.fetchAsync({ dataType: 'json', cache: true, timeout: 12000 });
		var fetchFresh = Utils.fetchAsync({ dataType: 'json', cache: false, timeout: 12000 });
		function safeJSON(call, defaultVal, label) {
			var dfd = $.Deferred();
			call
				.done(function (resp) { dfd.resolve(resp); })
				.fail(function (_jq, textStatus, err) {
					console.warn('[mountain-detail] failed:', label || 'request', textStatus || '', err || '');
					dfd.resolve(defaultVal);
				});
			return dfd.promise();
		}
		function asArray(v, fallback) {
			if (Array.isArray(v)) {
				if (v.length === 1 && Array.isArray(v[0])) { return v[0]; }
				return v;
			}
			return (fallback || []);
		}
		function asObject(v, fallback) {
			if (v && typeof v === 'object' && !Array.isArray(v)) { return v; }
			return (fallback || {});
		}
		var params = {
			page: (props && props.context && props.context.params && props.context.params.page) || '',
			detail: (props && props.context && props.context.params && props.context.params.detail) || ''
		};
		var model = {
			element: null,
			template: 'templates/mountain-weather.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: asObject((props && props.context && props.context.Model && props.context.Model.Main) || {}, {}),
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				venueMountainAreasData: null,
				venueMountainSubregionsData: null,
				skyConditions: null,
				mountainData: null,
				venueMountainSelectedRegionData: null,
				regionPreferredVenue: null,
				initialTimeLayoutId: null
			}
		};
		var langparam = (lang === 'lld' ? 'lld' : lang);
		var base = (WebBaseAprovLV.config.azureStorageUrl[lang] || '');
		var timeLayoutIds = ['144000000', '144001440', '144002880', '144004320', '144005760', '144007200'];
		var cb = Date.now();
		var pageReq = safeJSON(Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			{}, 'kk page');
		var tplMain = safeJSON(ejs.preloadTemplate(model.template), null, 'tpl main');
		var tplBreadcrumb = safeJSON(ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template), null, 'tpl breadcrumb');
		var tplBottom = safeJSON(ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template), null, 'tpl bottomnav');
		$.when(pageReq, tplMain, tplBreadcrumb, tplBottom).then(function (pageXhr) {
			var pageRaw = asObject(Array.isArray(pageXhr) ? pageXhr[0] : pageXhr, {});
			model.data.pageRaw = pageRaw;
			model.data.navRaw = {};
			var regionsReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/mountain_regions.json'), [], 'regions');
			var elevReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/elevations.json'), [], 'elevations');
			var skyReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/sky_conditions.json'), [], 'sky');
			var bulletinReqs = timeLayoutIds.map(function (id) {
				var url = base + 'forecast-data/website/mountains/' + langparam + '_' + id + '.json'
					+ (base.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb));
				return safeJSON(
					fetchFresh(url).then(function (resp) {
						var r = Array.isArray(resp) ? resp[0] : resp;
						return r || null;
					}),
					null,
					'bulletin:' + id
				);
			});
			return $.when.apply($, [regionsReq, elevReq, skyReq].concat(bulletinReqs));
		})
			.then(function () {
				var args = Array.prototype.slice.call(arguments);
				var regionsRaw = asArray(args[0], []);
				var elevRaw = asArray(args[1], []);
				var skyRaw = asArray(args[2], []);
				var publications = args.slice(3).map(function (v) { return v || null; })
					.filter(function (p) { return p && typeof p === 'object'; });
				var regions = (Utils.localizeMountainRecords && Utils.localizeMountainRecords(regionsRaw, lang)) || regionsRaw;
				var elevations = (Utils.localizeMountainRecords && Utils.localizeMountainRecords(elevRaw, lang)) || elevRaw;
				var regionIdx = (Utils.buildRegionIndexes && Utils.buildRegionIndexes(regions)) || {};
				var elevById = Object.create(null);
				elevations.forEach(function (v) { if (v && v.id != null) { elevById[String(v.id)] = v; } });
				var mergedMountainData = null;
				try {
					mergedMountainData = (Utils.mergeMountainBulletins &&
						Utils.mergeMountainBulletins(publications, elevById, regionIdx, lang)) || null;
				} catch (err) {
					console.warn('[mountain-detail] mergeMountainBulletins failed:', err);
					mergedMountainData = null;
				}
				var slugParam = (params.detail || '').toLowerCase();
				var selectedRegion = null;
				if (slugParam) {
					selectedRegion = regions.find(function (r) {
						return r && typeof r.url_slug === 'string'
							&& r.url_slug.toLowerCase() === slugParam;
					}) || null;
					if (!selectedRegion) {
						console.error('[mountain-detail] region not found:', params.detail);
						return WebBaseAprovLV.render404();
					}
				}
				if (!slugParam && regions.length) {
					selectedRegion = regions.slice().sort(function (a, b) {
						return (a.name || '').localeCompare(b.name || '');
					})[0];
				}
				var preferredVenue = null;
				if (selectedRegion && Utils.pickPreferredElevationForRegion && Utils.resolveRegionIdForElevation) {
					try {
						preferredVenue = Utils.pickPreferredElevationForRegion(
							elevations,
							selectedRegion.id,
							function (ev) { return Utils.resolveRegionIdForElevation(ev, regionIdx, lang); }
						) || null;
					} catch (err) {
						console.warn('[mountain-detail] pickPreferredElevationForRegion failed:', err);
						preferredVenue = null;
					}
				}
				var search = props && props.context && props.context.location && props.context.location.search;
				var tl = Utils.getQueryParam && Utils.getQueryParam('tl', search);
				var initialTimeLayoutId = (tl && /^\d+$/.test(tl)) ? tl : null;
				model.element = $('#content');
				if (!model.element.length) {
					console.warn('[mountain-detail] #content not found – creating fallback container');
					model.element = $('<div id="content"/>').appendTo('body');
				}
				var kkVM = Utils.getKKViewModel || function (x) { return [x || {}]; };
				model.data = $.extend(model.data, {
					pageContent: (kkVM(model.data.pageRaw)[0] || {}),
					nav: (kkVM(model.data.navRaw)[0] || {}),
					venueMountainAreasData: regions,
					venueMountainSubregionsData: elevations,
					skyConditions: skyRaw || [],
					mountainData: mergedMountainData,
					venueMountainSelectedRegionData: selectedRegion || null,
					regionPreferredVenue: preferredVenue || null,
					initialTimeLayoutId: initialTimeLayoutId
				});
				return Utils.transitionTo(model);
			})
			.then(function (ejsmodel) {
				try {
					var sel = (ejsmodel && ejsmodel.data && ejsmodel.data.venueMountainSelectedRegionData) || {};
					var slugs = (Utils.localizedSlugsForRegion && Utils.localizedSlugsForRegion(sel)) || { de: '', it: '', lld: '', en: '' };
					ejsmodel.data.UILangSwitch = Utils.tuneUILangSwitchers && Utils.tuneUILangSwitchers({
						page: {
							segment: {
								'de': 'bergwetter' + (slugs.de ? '/' + slugs.de : ''),
								'it': 'tempo-in-montagna' + (slugs.it ? '/' + slugs.it : ''),
								'lld': 'temp-sa-mont' + (slugs.lld ? '/' + slugs.lld : ''),
								'en': 'mountain-weather' + (slugs.en ? '/' + slugs.en : '')
							}
						},
						detail: { id: '' }
					}, $('a.langchange'));
				} catch (err) {
					console.warn('[mountain-detail] tuneUILangSwitchers skipped:', err);
				}
				var t1 = (window.performance && performance.now && performance.now()) || Date.now();
				console.info('[mountain-detail] load+render took', Math.round(t1 - t0), 'ms');
				dfdRoot.resolve(ejsmodel);
			})
			.fail(function (err) {
				console.warn('[mountain-detail] falling back to minimal render:', err);
				model.element = $('#content');
				if (!model.element.length) { model.element = $('<div id="content"/>').appendTo('body'); }
				model.data.pageContent = model.data.pageContent || {};
				model.data.nav = model.data.nav || {};
				model.data.venueMountainAreasData = model.data.venueMountainAreasData || [];
				model.data.venueMountainSubregionsData = model.data.venueMountainSubregionsData || [];
				model.data.skyConditions = model.data.skyConditions || [];
				model.data.mountainData = model.data.mountainData || null;
				$.when(Utils.transitionTo(model))
					.done(function (ejsmodel) { dfdRoot.resolve(ejsmodel); })
					.fail(function (e) { dfdRoot.reject(e); });
			});

		return dfdRoot.promise();
	};
})();
